import React, {useEffect, useState} from 'react';
import {View, Button, Text} from 'react-native';
import useLocalNotificationJSONManager from '../hooks/useLocalNotificationJSONManager';
import localNotificationHandler from "../hooks/localNotificationHandler";
import {navigate} from "../hooks/navigationService";
import styled from "styled-components/native";

import BannerGradient from '../../assets/gradient.png';
import BannerClock from '../../assets/clock2.png';
import ArrowGif from '../../assets/arrow.gif';

import {
    WorkoutsParent,
    WorkoutContainerText,
    WorkoutTextHeader,
    CerebrocoreCommonTextComponent,
    WorkoutContainerHeaderThree,
    WorkoutCommonButton,
    WorkoutCommonButtonTwo,
    WorkoutTextSubHeader
} from '../styles/common-styles';

import * as Notifications from "expo-notifications";
import {useFocusEffect} from "@react-navigation/native";

function ReminderBanner() {
    const [notifGroups, setNotifGroups] = useState([]);

    useFocusEffect(
        React.useCallback(() => {
            const getNotifications = async () => {
                const localNotifications = await Notifications.getAllScheduledNotificationsAsync();
                setNotifGroups(localNotifications);
            };
            getNotifications();
        }, [])
    );

    if(notifGroups.length == 0) {
        return (
            <BannerParent onPress={() => navigate('remindermanager')}>
                <BannerBG source={BannerGradient} resizeMode={'cover'}/>
                <BannerClockImg source={BannerClock}/>
                <BannerTextParent>
                    <BannerHeaderText>Set workout reminders!</BannerHeaderText>
                    <BannerSubHeaderText>Stay on track by setting reminders for you training</BannerSubHeaderText>
                </BannerTextParent>

                <BannerArrowGif source={ArrowGif} />
            </BannerParent>
        )
    }
}

export const BannerParent = styled.TouchableOpacity`
  height:65px;
  width:100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
`

export const BannerBG = styled.ImageBackground`
  width:100%;
  height:100%;
  position: absolute;
  top:0;
  left:0;
  right:0;
  bottom:0;
`

export const BannerClockImg = styled.ImageBackground`
  width:75px;
  height:75px;
  position: absolute;
  top:-5px;
  left:75%;
  right:0;
  bottom:0;
`

export const BannerTextParent = styled.View`
  margin-left:25px;
`

export const BannerHeaderText = styled(WorkoutContainerText)`
  color:white;
  font-size:20px;
`

export const BannerSubHeaderText = styled(WorkoutContainerText)`
  color:white;
  font-size:12px;
  margin-top:2.5px;
`

export const BannerArrowGif = styled.Image`
  width:75px;
  height:75px;
  margin-top:5px;
  margin-right:-15px;
  transform: rotate(270deg);
`

export default ReminderBanner;